module.exports = __webpack_public_path__ + "img/pen.eb82ea83.svg";